export default {
  loggedUser: {
    token: null,
    email: null,
    role: null,
    permissions: null,
    location: null,
    locationLogo: null,
    marketSegments: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js